import PropTypes from "prop-types";
import Alert from "@shared/v2/Alert";
import Avatar from "@shared/v2/Avatar";
import Typography from "@shared/v2/Typography";
import { EyeSlashSolidV6 } from "@shared/v2/Icomoon";
import Button from "@shared/v2/Button";

const ForbiddenError = ({
  error: {
    assigned_to: { primary_agent: primaryAgent, lead_pond: leadPond },
  },
  onRefresh,
}) => (
  <div className="tw-p-[16px] tw-h-full">
    <div className="tw-h-full tw-bg-white tw-rounded-[4px] tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[12px]">
      <EyeSlashSolidV6 size="xxl" />
      <Typography variant="headline2">Sorry, you do not have access</Typography>
      <Alert
        containerClass="tw-max-w-[450px] tw-w-full"
        variant="gray"
        text={
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-[12px]">
            <span>This contact is assigned to:</span>
            <div className="tw-flex tw-items-center tw-gap-[8px]">
              <Avatar src={primaryAgent?.avatar_url} alt={primaryAgent?.full_name || leadPond?.name} />
              <span className="tw-font-bold">{primaryAgent?.full_name || leadPond?.name}</span>
            </div>
          </div>
        }
      />
      <Typography className="tw-max-w-[450px] tw-text-center">
        If you believe this is a mistake, you can ask an administrator on your team to add you as an assigned
        team member and refresh the page.
      </Typography>
      <Button size="medium" schema="tertiary" onClick={onRefresh}>
        Refresh
      </Button>
    </div>
  </div>
);

ForbiddenError.propTypes = {
  error: PropTypes.shape({
    assigned_to: PropTypes.shape({
      primary_agent: PropTypes.shape({
        full_name: PropTypes.string,
        avatar_url: PropTypes.string,
      }),
      lead_pond: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }).isRequired,
  onRefresh: PropTypes.func.isRequired,
};

export default ForbiddenError;
